import {useCookie} from './useCookie';
import {computed} from 'vue';
import {useDeviceStorage} from './useDeviceStorage/useDeviceStorage';

/**
 * Creates a ref that is synced to both local storage (or capacitor storage) and cookies.
 * @param key The key that will be used for local storage. For cookies, the prefix 'security.' will be removed.
 */
export function useSecurityStorage<T extends string | boolean = string>(
    key: string,
    initialValue?: T | null
) {
    const cookieKey = key.replace('security.', '');

    const storageValue = useDeviceStorage(key, initialValue ?? null);
    const cookieValue = useCookie(cookieKey, initialValue ?? null);

    return computed({
        get() {
            return cookieValue.value || storageValue.value;
        },
        set(value) {
            storageValue.value = value;
            cookieValue.value = value;
        },
    });
}
